export default "__VITE_ASSET__DLpwl6EW__"